import TrustedShops from './TrustedShops.vue'

export default TrustedShops
